module.exports = __webpack_public_path__ + "img/na-service-ranges-graph-screen.71f6e0c9.png";